module.exports = __webpack_public_path__ + "static/media/msg-icon.a2091eb4.jpg";